import api from '../../api'

const SET_TEACHERS = 'SET_TEACHERS'
const SET_TOTAL = 'SET_TOTAL'

export default {
  namespaced: true,
  state: {
    teachers: [],
    total: 0
  },
  mutations: {
    [SET_TEACHERS] (state, teachers) {
      state.teachers = teachers
    },
    [SET_TOTAL] (state, total) {
      state.total = total
    }
  },
  actions: {
    getTeachers: async ({commit}, {offset, limit, role, period}) => {
      let response = await api.teachers.list(offset, limit, role, period)
      if (response.success) {
        commit(SET_TOTAL, response.total)
        commit(SET_TEACHERS, response.teachers)
      }
    },
    getAllTeachers: async ({commit}, {role, period}) => {
      let response = await api.teachers.list(0, -1, role, period)
      if (response.success) {
        commit(SET_TEACHERS, response.teachers)
      }
    }
  },
  getters: {}
}
